// =============================================================================
// bubbles/MediaPlaceholders.tsx — Estados sem mídia da MediaBubble (F58-S14).
//
// - MediaLoadingPlaceholder: skeleton "Recebendo …" (F45-S04). Nunca ícone
//   quebrado nem espaço vazio (DS anti-padrão "loading engasgado").
// - MediaUnavailablePlaceholder: o arquivo não veio ou a URL venceu. Texto
//   claro, sem jargão, no lugar do "Recebendo…" eterno (CONV-04).
// =============================================================================

import * as React from 'react';

interface MediaPlaceholderProps {
  /** Ícone do tipo de mídia. */
  readonly icon: React.ReactNode;
  /** Rótulo do tipo, já em minúsculas (ex.: "imagem"). Só o skeleton usa. */
  readonly label: string;
  /** Rodapé da bolha (horário/status). */
  readonly footer: React.ReactNode;
  readonly className: string;
}

export function MediaLoadingPlaceholder({
  icon,
  label,
  footer,
  className,
}: MediaPlaceholderProps): React.JSX.Element {
  return (
    <div className={className} aria-live="polite">
      <div className="flex items-center gap-2 text-ink-3">
        <span className="animate-pulse">{icon}</span>
        <span className="text-xs">Recebendo {label}…</span>
      </div>
      <div
        aria-hidden="true"
        className="mt-2 h-16 w-40 rounded-xs animate-pulse"
        style={{ background: 'var(--surface-muted)' }}
      />
      {footer}
    </div>
  );
}

export function MediaUnavailablePlaceholder({
  icon,
  footer,
  className,
}: MediaPlaceholderProps): React.JSX.Element {
  return (
    <div className={className} role="status" data-media-state="unavailable">
      <div className="flex items-center gap-2 text-ink-3">
        <span>{icon}</span>
        <span className="text-xs font-medium">Mídia indisponível</span>
      </div>
      <p className="mt-1 text-xs text-ink-3">
        Não foi possível carregar este arquivo. Peça para o contato enviá-lo de novo.
      </p>
      {footer}
    </div>
  );
}
